import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateTicketComponent from "../../../components/Customer/tickets/CreateTicketComponent";

const CreateTicketPage = () => {
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate('/ho-tro/danh-sach-ho-tro.html');
    }

    return <CreateTicketComponent   shouldRedirect={ () => redirectBack() }
    />;

}

export default CreateTicketPage;